import { gql } from '@apollo/client';

export const FETCH_GOOGLE_USER = gql`
  query Flex_FetchGoogleUser($code: String!, $secureToken: String!) {
    googleUser: thirdPartyUser(
      accessCode: $code
      app: funnel
      platform: google
      state: $secureToken
    ) {
      email
      firstName
      lastName
    }
  }
`;
